module.exports = __webpack_public_path__ + "static/programme-7f85bf2adea81f32f832cd1ac7850e22.jpg";